import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import industryMasterService from "../../../services/masters/industryMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

import { rows } from "./../MastersFakeDb";
import { editDeleteIndustry, getIndustryList } from "../../../actions/actions";
const IndustryList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.industry.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.industry.rows_per_page || 15);
  // const rows = useSelector((state) => state.industry.industry);
  const [rows, setRows] = useState([]);
  console.log(rows, "rows")
  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "dress_type", "cost"];
  const labels = ["Id", "dress_type", "cost"];

  // const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = "test";
  // const respMsgState = useSelector((state) => state.industry.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      }
      const response = await industryMasterService.getIndustryList(params);
      setRows(response);
    }
    catch (error) {
      console.error("Error fetching data:", error);
      setSuccessMessage("Error fetching data");
    }
  };

  // const handleSearch = (e) => {
  //   setSearchKey(e.target.value);
  //   const params = {
  //     page: controller.page,
  //     size:
  //       e.target.value === ""
  //         ? controller.rowsPerPage
  //         : rows[0]?.total_count || 0,
  //     searchKey: e.target.value,
  //   };
  //   dispatch(getIndustryList(params));
  // };
  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);  // Set the search key
    
    // Prepare the params based on the search value
    const params = {
        page: controller.page,
        size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
        searchKey: searchValue,
    };

    try {
        // Fetch data using the fetchData function (assuming fetchData is already declared)
        await fetchData(params);
    } catch (error) {
        console.error("Error in handleSearch:", error);
    }
};

  useEffect(() => {
    fetchData();
  }, [controller]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => {}, [shouldShowMsg, responseMessage]);

  const deleteRecord = async (id) => {
    try {
      await industryMasterService.editDeleteIndustry({
        industry_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    if (successMessage) {
      // Clear the success message after a few seconds
      const timer = setTimeout(() => setSuccessMessage(successMessage), 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);
  //const respMsgState = 'test'
  // const respMsgState = useSelector((state) => state.industry.message);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
  // useEffect(() => {
  //   if (respMsgState) {
  //     setSuccessMessage(respMsgState);
  //   }
  // }, [respMsgState]);
  // useEffect(() => {
  // }, [shouldShowMsg, responseMessage,]);




  // Sort rows by entry_date descending
  const sortedRows = Array.isArray(rows)
  ? [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date))
  : [];

  // console.log('Sorted Rows:', sortedRows);
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  // console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });




  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            // { name: 'Dashbord', path: '/dashboard' },
            { name: "Industry List" },
          ]}
        />


        <HeaderSection
          title="INDUSTRY LIST"
          addNewPath="/masters/add-industry"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Charges List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />






        <Paper sx={{ width: '100%',  }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("indus_name", sortBy, setSortBy, rows)
                    }
                  >
                    Industry Type
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "indus_name" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row, index) => (
                    <StyledTableRow
                      key={row.industry_id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <StyledTableCell className={`${styles.list_table_body}`}>
                        {row.industry_name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/masters/add-industry"
                           handlePrint ={false}
                              handleCancel={false}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
                       <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.industry_id || null}
          displayName={deleteInfo?.industry_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default IndustryList;
